<template>
  <router-view >
  </router-view>
</template>
<script setup>
import BackgroundMusic from "@/components/backgroundMusic/backgroundMusic"
import customConfig from '/customConfig.js'
import {useRoute, useRouter} from "vue-router";
window.$route=useRoute()
window.$router=useRouter()
</script>
<style lang="less">
#app {
  width: 100vw;
  height: 100vh;
}
*{
  margin: 0;
  padding: 0;
}
body {
  width: 100vw;
  height: 100vh;
}
.fade-right-enter-to,
.fade-right-leave-from{
  opacity: 1;
  transform: none;
}
.fade-right-enter-active,
.fade-right-leave-active
{
  transition: all .1s;
}
.fade-right-enter-from,
.fade-right-leave-to{
  opacity:.5;
  transform: scale(1.05);
}
input{
  border: none;
  outline: none;
}
</style>
